import type { FaireProductEntity } from "../../entity_types/product";

export const p_zzgbqepwws: FaireProductEntity = {
  token: "p_zzgbqepwws",
  type: "product",
  name: "Christmas-Inspired Cozy Chenille Sweater Cropped Fit Top",
  brandToken: "b_ao33aibi2o",
  brandName: "Pol Clothing",
  imageUrl:
    "https://cdn.faire.com/fastly/036bbffc8084f1a659ad58e58566a45f636d2ba5a6a12af6a4ab24c91d62d6b3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/52bdb6fd03ac9a2534e7cad0e2bce803d2dca1695a5ad3292b4bedfc35abad9c.jpeg",
    "https://cdn.faire.com/fastly/adf8398ba5b8fa6565deb05cb511b1b8cd63c2ab70a87dcfe0e8ea289bda597c.jpeg",
    "https://cdn.faire.com/fastly/fd1ab14b40f1c1e6e597fd3599a21f121c26fd4726a176bdd8192e7fd7502d24.jpeg",
    "https://cdn.faire.com/fastly/966694423a1a2d2e4ff9a393ab168845c97b56a2c5de6e5bb4872e0a114e7d92.jpeg",
    "https://cdn.faire.com/fastly/8fbe58d730d9da1d22b7747a60b4576eef95244c16e447be0ff8fd615503e40b.jpeg",
    "https://cdn.faire.com/fastly/579140568d9e5b23efd4175d705cab14b541e11d24cc40457b1fba0f78e05a33.jpeg",
    "https://cdn.faire.com/fastly/c468da63f212efac38dd732a2bb3c2603ebb052e3e8325ba43046c6de2f591e3.jpeg",
    "https://cdn.faire.com/fastly/7675ed71d940889e4985b41979ca3ac42bb130fad99106f02c529e1c87c481bd.jpeg",
    "https://cdn.faire.com/fastly/64615c1d1f43da9bd772dbde425fee811e0e0a2a961ce363c901ce2b479aab95.jpeg",
    "https://cdn.faire.com/fastly/28ee140dcc2f3a52bc4202deae92e8e00941bb75b12acf910ebc4681ec13523f.jpeg",
    "https://cdn.faire.com/fastly/bae9b3e3728252368fe40dc6bdb76e955eb280e579a8af5f9cb4446dc6d1c264.jpeg",
    "https://cdn.faire.com/fastly/531e631fc8e6d1b34e62e52c81b97175b89e584bde5b43f2438024e8b093b566.jpeg",
    "https://cdn.faire.com/fastly/9dd6202e36d2b888e245f368cbcffb78b8eff1b2a525ac93c498f41bf8505be9.jpeg",
    "https://cdn.faire.com/fastly/3eb4985c5f4b0ae88860cf26ebba78c4eed34c4e81b6d94da83e896ed0a56af4.jpeg",
  ],
  priceDollars: 168,
  description:
    'Cozy chenille sweater top designed with a stylish mock neckline and modern cropped fit silhouette. Features voluminous balloon sleeves and festive Christmas-inspired details for a seasonal statement look. The soft chenille knit offers a plush texture and comfortable feel, making it perfect for holiday gatherings, winter styling, and everyday wear. Pair effortlessly with denim, skirts, or layered pieces for a cozy holiday outfit.\n\nSpecs/Dimensions:\n- BUST: 24-1/2"\n- LENGTH (Front and Back): 22-1/4"\n- SLEEVE: 22-1/4"\n- SHOULDER: 22-1/2"',
  tags: [],
  msrpDollars: 420,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:24.604Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
